import React from 'react';
import { useDispatch } from 'react-redux';
import {
  CModal,
  CModalBody,
  CModalHeader,
} from '@coreui/react';
import PropTypes from 'prop-types';
import CIcon from '@coreui/icons-react';
import ChatComponent from '../ChatComponent';
import { reloadMessages } from '../ChatComponent/actionCreators';

const propTypes = {
  onClose: PropTypes.func.isRequired,
  recruitName: PropTypes.string,
  chatID: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

const defaultProps = {
  chatID: null,
  recruitName: 'Recruit',
};

const ChatDialog = ({
  onClose, chatID, recruitName,
}) => {
  const dispatch = useDispatch();

  const onReloadMessagesClick = () => {
    dispatch(reloadMessages());
  };

  return (
    <CModal show onClose={onClose}>
      <CModalHeader closeButton>
        <div className="w-100 d-flex align-items-center">
          <h4 className="mb-0">Conversation history</h4>
          <button
            type="button"
            onClick={onReloadMessagesClick}
            className="chat-icon"
            title="Reload messages"
          >
            <CIcon name="cil-reload" alt="->" />
          </button>
        </div>
      </CModalHeader>
      <CModalBody>
        <ChatComponent
          chatID={chatID}
          recruitName={recruitName}
        />
      </CModalBody>
    </CModal>
  );
};

ChatDialog.propTypes = propTypes;
ChatDialog.defaultProps = defaultProps;

export default ChatDialog;
